import { NameMapEntry } from '@models/common';

const UNKNOWN_NAME = '-';

export function toNameMap(entries: NameMapEntry[]): Map<string, string> {
  return new Map(entries.map((entry) => [entry.Key, entry.Value]));
}

export function resolveMappedName(nameMap: Map<string, string>, id: string | undefined): string {
  return (id ? nameMap.get(id) : undefined) ?? UNKNOWN_NAME;
}
